import { render, staticRenderFns } from "./goodtable.vue?vue&type=template&id=12e08677&"
import script from "./goodtable.vue?vue&type=script&lang=js&"
export * from "./goodtable.vue?vue&type=script&lang=js&"
import style0 from "./goodtable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports